import { render, staticRenderFns } from "./ComplianceUpdates.vue?vue&type=template&id=4a94a6fc&"
import script from "./ComplianceUpdates.vue?vue&type=script&lang=js&"
export * from "./ComplianceUpdates.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceUpdates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports